// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"W6UA5","Pagination__Link":"CsObS","Pagination__Dots":"mEKin","Pagination__Dot":"_6YTU1","Pagination__Link_active":"snEFI","Pagination__ScreenreaderText":"hPOLZ"};